export default __webpack_public_path__ + "static/media/app-store.9683fb05.png";